import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Sparkles, Loader2 } from "lucide-react";
export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary/5 px-4">
      <Card className="w-full max-w-md p-8 rounded-2xl shadow-lg">
        <div className="flex items-center gap-2 mb-6">
          <img src="/mgd-logo.png" alt="My Global Dentist" className="h-10 w-auto" />
        </div>
        <h1 className="font-heading text-2xl font-bold">Welcome back</h1>
        <p className="text-muted-foreground text-sm mt-1">Sign in to manage clinics and leads.</p>
        <form onSubmit={submit} className="space-y-4 mt-6">
          <div className="space-y-2">
            <Label>Email</Label>
            <Input className="h-12" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@myglobaldentist.com" data-testid="login-email-input" required />
          </div>
          <div className="space-y-2">
            <Label>Password</Label>
            <Input className="h-12" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="login-password-input" required />
          </div>
          {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
          <Button type="submit" className="w-full rounded-full h-12" disabled={loading} data-testid="login-submit-btn">
            {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Sign in
          </Button>
        </form>
      </Card>
    </div>
  );
}
